import { commoditySaveAndShelve } from '@/api/shopCenter/index.js'
const state = {
  // 基本信息数据
  baseInfo: {},
  fxyInfo: {},
  videoInfo: {},
  douDianInfo: {},
  globImages: [],
  btnLoading: false
}

const mutations = {
  SET_GLOB_IMAGES: (state, data) => {
    state.globImages = data
  },
  // 写入基本信息
  SET_BASE_INFO: (state, data) => {
    state.baseInfo = data
  },
  // 清空基本信息
  CLEAR_BASE_INFO: state => {
    state.baseInfo = {}
  },
  // 写入抖店信息
  SET_DOU_DIAN_INFO: (state, data) => {
    state.douDianInfo = data
  },
  // 清空抖店信息
  CLEAR_DOU_DIAN_INFO: state => {
    state.douDianInfo = {}
  },
  // 写入视频号信息
  SET_VIDEO_INFO: (state, data) => {
    state.videoInfo = data
  },
  // 清空视频号信息
  CLEAR_VIDEO_INFO: state => {
    state.videoInfo = {}
  },
  // 写入伏羲云信息
  SET_FXY_INFO: (state, data) => {
    state.fxyInfo = data
  },
  // 清空伏羲云信息
  CLEAR_FXY_INFO: state => {
    state.fxyInfo = {}
  },
  SET_BTN_LOADING: (state, data) => {
    state.btnLoading = data
  }
}

const actions = {
  setBtnLoading({ commit }, data) {
    commit('SET_BTN_LOADING', data)
  },
  setBaseInfo({ commit }, data) {
    commit('SET_BASE_INFO', data)
  },
  setDouDianInfo({ commit }, data) {
    commit('SET_DOU_DIAN_INFO', data)
  },
  getBaseInfo({ commit }) {
    return state.baseInfo
  },
  setVideoInfo({ commit }, data) {
    commit('SET_VIDEO_INFO', data)
  },
  setFxyInfo({ commit }, data) {
    commit('SET_FXY_INFO', data)
  },
  getGlobImages({ commit }) {
    return state.globImages
  },
  setGlobImages({ commit }, data) {
    commit('SET_GLOB_IMAGES', data)
  },
  clearALL({ commit }) {
    // 清空数据
    commit('CLEAR_BASE_INFO')
    commit('CLEAR_DOU_DIAN_INFO')
    commit('CLEAR_FXY_INFO')
    commit('CLEAR_VIDEO_INFO')
    commit('SET_GLOB_IMAGES', [])
  },
  // 保存并上架
  saveAndShelve({ commit, state, dispatch }, data) {
    const params = {}
    data.forEach(e => {
      // 商品信息
      if (e.key === 'BasicInfo') {
        params.commodity = state.baseInfo

        if (params.commodity?.originSkuDefine) {
          delete params.commodity.originSkuDefine
        }
        if (params.commodity?.originSkuList) {
          delete params.commodity.originSkuList
        }
        if (params.commodity?.coverVideoUrl) {
          delete params.commodity.coverVideoUrl
        }
      }
      // 抖店商品信息
      if (e.key === 'DouyinInfo') {
        params.douDianProductReq = state.douDianInfo
      }
      // 伏羲云商品信息
      if (e.key === 'FxyInfo') {
        if (state.fxyInfo.goodsType === 5 || state.fxyInfo.goodsType === '5') {
          params.fxyMaterialGoodsOffline = state.fxyInfo
        } else {
          params.fxyMaterialGoods = state.fxyInfo
        }
      }
      // 视频号小店商品信息
      if (e.key === 'VideoInfo') {
        params.wechatProductCreateBatchReq = state.videoInfo
      }
    })
    console.log(params, 'saveAndShelvesaveAndShelve')
    return new Promise((resolve, reject) => {
      commoditySaveAndShelve(params)
        .then(res => {
          // 清空数据
          dispatch('clearALL')
          resolve(res)
        })
        .catch(err => {
          dispatch('setBtnLoading', false)
          reject(err)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
